import { supabase } from "../lib/supabaseClient.ts";

export async function testCommunityReportsTable() {
  try {
    // Test if table exists by trying to select from it
    const { data, error } = await supabase
      .from('community_reports')
      .select('count')
      .limit(1);

    if (error) {
      console.error('Table does not exist or has permission issues:', error);
      return { exists: false, error: error.message };
    }

    console.log('✅ community_reports table exists and is accessible');
    return { exists: true, error: null };
  } catch (error) {
    console.error('Database connection error:', error);
    return { exists: false, error: 'Connection failed' };
  }
}

export async function testStorageBuckets() {
  try {
    // Test community-photos bucket
    const { data: photosData, error: photosError } = await supabase.storage
      .from('community-photos')
      .list('', { limit: 1 });

    // Test community-audio bucket  
    const { data: audioData, error: audioError } = await supabase.storage
      .from('community-audio')
      .list('', { limit: 1 });

    return {
      photos: { exists: !photosError, error: photosError?.message },
      audio: { exists: !audioError, error: audioError?.message }
    };
  } catch (error) {
    console.error('Storage test error:', error);
    return {
      photos: { exists: false, error: 'Connection failed' },
      audio: { exists: false, error: 'Connection failed' }
    };
  }
}